import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="card-lift group block overflow-hidden rounded-lg bg-background-100"
      aria-label={`${comic.title} 详情`}
    >
      <div className="relative overflow-hidden bg-background-200 aspect-[3/4]">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩漫封面`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
        <span className="absolute left-2 top-2 rounded bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {comic.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-2.5 text-background-50">
          <span className="flex items-center gap-1 text-xs">
            <i className="ri-star-fill text-accent-400"></i>
            {comic.score}
          </span>
          <span className="text-xs opacity-90">{comic.views} 人气</span>
        </div>
        {rank !== undefined && (
          <span className="absolute -bottom-3 -left-1 flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg text-background-50 shadow-lg">
            {rank}
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950">{comic.title}</h3>
        <p className="mt-1 flex items-center justify-between text-xs text-foreground-600">
          <span className="truncate">{comic.category}</span>
          <span>{comic.chapters} 话</span>
        </p>
      </div>
    </Link>
  );
}